import { DTOToTemplate, templateToDTO } from '@/api/templateMapper';
import { InvalidProjectFormatError } from '@/domain/template/InvalidProjectFormatError';
import { initImages, saveImages } from '@/utils/idbImageStorage';
import type { ITemplate } from '@/domain/template/ITemplate';
import type { TInitImagesResult } from '@/utils/idbImageStorage';
import type { ITemplateDTO } from '@/domain/template/ITemplateDTO';

async function saveToLocalStorage(template: ITemplate, currentProjectId: string) {
    await saveImages(template, currentProjectId);
    window.localStorage.setItem(currentProjectId, JSON.stringify(templateToDTO(template)));
    return currentProjectId;
}

async function loadFromLocalStorage(projectId: string): Promise<TInitImagesResult | undefined> {
    const serializedTemplate = window.localStorage.getItem(projectId);
    if (!serializedTemplate) {
        return undefined;
    }
    // Unreadable JSON is the same problem as a drifted project, and it has the same channel:
    // as a SyntaxError it was not recognised, and reached the caller as a programming error.
    let templateDTO: ITemplateDTO;
    try {
        templateDTO = JSON.parse(serializedTemplate) as ITemplateDTO;
    } catch (error) {
        throw new InvalidProjectFormatError(`stored draft is not readable JSON: ${error instanceof Error ? error.message : String(error)}`);
    }

    return await initImages(DTOToTemplate(templateDTO), projectId);
}

// Called when a stored project is refused by the schemas: nothing else removes the entry, so
// every reload would replay the same refusal on the same unreadable data.
function clearLocalStorageProject(projectId: string): void {
    window.localStorage.removeItem(projectId);
}

export { clearLocalStorageProject, loadFromLocalStorage, saveToLocalStorage };
